var popt = 'erte';